import { JDSMegaMenuItemProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSMegaMenuItemProps>
  ): React.FC<JDSMegaMenuItemProps> =>
  (props: JDSMegaMenuItemProps) => {
    return <Component {...props} />;
  };
